import { WalletNetwork } from '@moonpay/login-common';

export const walletNetworkOrionSupportedNetworkTypeMapping = {
  [WalletNetwork.Bitcoin]: 'bitcoin',
  [WalletNetwork.Ethereum]: 'evm',
  [WalletNetwork.Solana]: 'solana',
  [WalletNetwork.Ripple]: 'ripple',
};
